export default "__VITE_ASSET__C_w6CfvX__"